export const paths = {
	enumPage: (enumName: string) => `/internal-tools/enums/${enumName}`,
	structPage: (structName: string) => `/internal-tools/structs/${structName}`,
};
